import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import RedirectExternal from '#client/components/RedirectExternal';
import { ENABLE_FREEDASH_ROUTING } from '#client/constants/experimentsFlags';
import { generateEntitlements } from '#client/utils/entitlements';
import getPricingDeviations from '#client/utils/pricing';
import { generateZenUrl } from '#client/utils/urls';

import { SIMULATED_NAME } from './constants';
import Home from './Home';
import useHomeQuery from './useHomeQuery';

const Renderer = () => {
  const { businessEntityUuid, businessEntity: contextBE } = useBusinessEntity();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const {
    pricing,
    accountInfo,
    businessEntity,
    businessEntities,
    orderTasks,
    businessEntityCount,
    loading,
    journeyRedirect
  } = useHomeQuery({
    businessEntityUuid,
    timezone
  });
  const enableFreedashRouting = useExperimentFlag(ENABLE_FREEDASH_ROUTING, false);
  const isSimulated = contextBE?.isSimulated;
  const entitlements = generateEntitlements(orderTasks);
  const hasPaidEntities = businessEntities?.some(
    ({ businessEntityName }) => businessEntityName !== SIMULATED_NAME
  );
  const worryFreeServicePurchased = entitlements.has('worry_free_service') || entitlements.has('starter_plan_v26');
  const pricingDeviations = getPricingDeviations([...pricing], worryFreeServicePurchased);
  /* if the BE is simulated has any order task that means something was purchased, show dashboard */
  const hasPurchasedProducts = enableFreedashRouting
    && isSimulated
    && orderTasks.filter((task) => !task.orderTaskType?.includes('formation')).length > 0;

  /*
   * if account is freedash redirect to funnel since it's deprecated,
   * unless there are other formed entities or purchased products
   */
  if (!loading && isSimulated && !hasPaidEntities && !hasPurchasedProducts) {
    const redirectUrl = generateZenUrl('/formation-types-compare/');
    return <RedirectExternal href={redirectUrl} />;
  }

  /*
   * if account has started the boi flow but not completed redirect them to the flow
   */
  if (!loading) {
    const { shouldRedirect, redirectUrl } = journeyRedirect;
    if (shouldRedirect) {
      return <RedirectExternal href={redirectUrl} />;
    }
  }

  return (
    <Home
      account={accountInfo}
      businessEntity={businessEntity}
      businessEntityCount={businessEntityCount}
      entitlements={entitlements}
      loading={loading}
      pricingDeviations={pricingDeviations}
    />
  );
};

export default Renderer;
